<template>
  <div class="pay-card-container">
    <a-tabs
      :defaultActiveKey="defaultActiveKey"
      @change="tabChangeHandler"
      type="card">
      <a-tab-pane
        v-for="(method, mId) in payMethodGroup"
        :tab="method.title"
        :key="mId + ''"
      >
        <div class="pay-type-item"
             v-for="(bank, bankIndex) in method.items"
             :class="[{'active': bank.id === selectedBank.id}]"
             :key="bankIndex"
             :title="bank.label"
             :data-bankId="bank.bankId"
             :data-payType="bank.payType"
        >
          <i class="pay-type-icon" :class="[bank.id, bank.class]" @click="selectPayHandler(bank, true)">
            <template v-if="['alipYFK', 'YEEPAYCREDIT', 'ICBC-BIND', 'VR_PAY'].indexOf(bank.id) > -1">
              <span>{{ bank.label }}</span>
            </template>
          </i>
          <template v-if="bank.id === 'HB'">
            <ant-credit-pay v-show="bank.id === selectedBank.id"  @selectPeriods='onSelectPeriods'></ant-credit-pay>
          </template>
        </div>
      </a-tab-pane>
    </a-tabs>
    <!--微信二维码支付弹窗-->
    <a-modal
      title="微信扫一扫支付"
      v-model="wxPayCodeVisible"
      wrapClassName="wx-pay-modal"
      :footer="null"
      @cancel="wxPayCancelHandler"
    >
      <div class="wx-pay-code">
        <img :src="wxPayCode" alt="微信扫一扫支付">
      </div>
    </a-modal>
    <!--虚拟账户预约弹窗-->
    <a-modal
      title="虚拟支付提示"
      v-model="vrPayModalVisible"
      wrapClassName="vr-pay-modal"
      :closable="false"
      :maskClosable="false"
      cancelText="取消支付"
      okText="确认支付"
      :okButtonProps="vrPayOkButtonProps"
      @ok="vrPayInfoOkHandle"
    >
      <div>虚拟账户信息：</div>
      <div class="vr-info-item">
        <div class="vr-label">虚拟币可使用余额</div>
        <div class="vr-context">￥{{ vrPayInfo.balanceAmount }}</div>
      </div>
      <div class="vr-info-item">
        <div class="vr-label">本日最大限额</div>
        <div class="vr-context">￥{{ vrPayInfo.limitDayAmount }}</div>
      </div>
      <div class="vr-info-item">
        <div class="vr-label">本日剩余额度</div>
        <div class="vr-context">￥{{ vrPayInfo.surplusAmount }}</div>
      </div>
      <div class="vr-pay-note" v-if="vrPayOkButtonProps.props.disabled">当日余额不足，请使用其他方式支付</div>
    </a-modal>
  </div>
</template>

<script>
import { payOrder, virtualPayInfo, showQRCode, payState } from '@/apis/pay'
import antCreditPay from './module/antCreditPay'
import './css/pay-bank.less'
import payMethodGroup from './payMethod.js'
import _ from 'lodash'

const mainSettings = window.__MICRO_ROOT__ ?? {}

const payHidden = [{
  title: '其他支付方式',
  items: [
    { id: 'VR_PAY' }
  ]
}]

export default {
  name: 'l8-pay-box',
  components: {
    antCreditPay
  },
  props: {
    payExtend: {
      type: Object,
      default: function () {
        return {
          // filter、hidden不能同时设置
          filter: [],
          hidden: payHidden,
          extend: []
        }
      }
    },
    defaultActiveKey: {
      type: String,
      default: function () {
        return '0'
      }
    }
  },
  data () {
    return {
      payMethodGroup: payMethodGroup,
      payMethodGroupClone: payMethodGroup,
      selectedBank: {},
      payParams: {},
      wxPayCode: '',
      wxPayCodeVisible: false,
      pollPayInt: '',
      pollPayIntCount: 6,
      returnUrl: '',
      wxPayReturnUrl: '',
      extraCommonParam: '',
      vrPayModalVisible: false,
      vrPayInfo: {},
      vrPayOkButtonProps: { props: { disabled: false } }
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  watch: {
    payExtend: {
      handler: function (newValue) {
        this.freshPayMethods(newValue)
      },
      deep: true,
      immediate: true
    }
  },
  async created () {
    const { payExtend } = this
    await this.getPayMethodGroup()
    await this.freshPayMethods(payExtend)
  },
  methods: {
    async getPayMethodGroup () {
      try {
        const { payMethodSettings } = await window.__MICRO_ROOT__?.cms?.getPageData()
        const { menus } = payMethodSettings
        if (menus) {
          for (let index = 0; index < menus.length; index++) {
            menus[index].items = menus[index].children
            delete menus[index].children
          }
          this.payMethodGroup = menus || payMethodGroup
          this.payMethodGroupClone = _.clone(this.payMethodGroup)
        }
      } catch (err) {
        console.log('err >>>> ', err)
      }
    },
    freshPayMethods (data) {
      let group = JSON.parse(JSON.stringify(this.payMethodGroupClone))

      // filter、hidden不能同时设置
      if (data.filter && data.filter.length) {
        group = this.doFilterPayMethod(data.filter, group)
      } else {
        if (typeof data.hidden === 'undefined') {
          data.hidden = payHidden
        }

        if (data.hidden && data.hidden.length) {
          this.doHiddenPayMethod(data.hidden, group)
        }
      }

      if (data.extend && data.extend.length) {
        this.doExtendPayMethod(data.extend, group)
      }

      this.payMethodGroup = group
      if (group.length === 1 && group[0].items.length === 1) {
        this.selectPayHandler(group[0].items[0])
      }
    },
    selectPayHandler (bank, isClick = false) {
      this.selectedBank = (bank.bankId === this.selectedBank.bankId && isClick) ? {} : bank
    },
    wxPayCancelHandler () {
      window.clearTimeout(this.pollPayInt)
      this.$emit('paid', this.selectedBank, 'CLOSE')
    },
    async doPay (order) {
      const { orderId, orderNo, amount, orderType, returnUrl, extraCommonParam, wxPayReturnUrl = '' } = order

      this.returnUrl = returnUrl
      this.wxPayReturnUrl = wxPayReturnUrl
      this.extraCommonParam = extraCommonParam

      if (!this.selectedBank.bankId && !this.selectedBank.payType) {
        this.$message.error('请选择支付方式！')
        return Promise.reject(new Error('请选择支付方式！'))
      }

      const ifInternational = this.ifInternational?.() ?? false
      const params = {
        'orderId': +orderId || orderId,
        'orderNo': orderNo,
        'payType': this.selectedBank.payType,
        'amount': +amount,
        'bankId': this.selectedBank.bankId,
        'orderType': orderType,
        'extraCommonParam': extraCommonParam,
        'returnUrl': `${location.origin}${returnUrl}`,
        ifInternational
      }

      if (params.payType === 'HB') {
        if (this.periods) {
          params.numOfPeriods = this.periods
        } else {
          this.$message.error('请先选择花呗分期期数')
          return false
        }
      }
      this.payParams = params

      // TICKET("机票")
      // CHANGE("改升")
      // EXTRA("单独辅营")

      this.$emit('paying', this.selectedBank)

      if (params.payType === 'VR_PAY') {
        try {
          let vrPayBalance = await this.fetchVRPay()
          let checkResult = this.checkVrPayBalance(vrPayBalance, order)

          console.log(vrPayBalance)
          this.vrPayInfo = vrPayBalance

          if (checkResult) {
            this.vrPayOkButtonProps = { props: { disabled: false } }
            this.vrPayModalVisible = true
          } else {
            this.vrPayOkButtonProps = { props: { disabled: true } }
            this.vrPayModalVisible = true
          }
          return Promise.resolve(vrPayBalance)
        } catch (e) {
          return Promise.reject(new Error(e.message || '获取虚拟支付信息失败'))
        }
      } else {
        return this.postPay()
      }
    },
    async postPay () {
      const params = this.payParams
      payOrder(params).then((res) => {
        if (res.url) {
          if (params.bankId === 'WX') {
            this.showWxQRCode(res.paymentNo, res.url)
          } else if (params.payType === 'CCB_PAY') {
            this.showWxQRCode(res.paymentNo, decodeURIComponent(res.url))
          } else {
            this.$emit('paid', this.selectedBank, 'SUCCESS')
            window.open(res.url, 'blank')
          }
        }
      }).catch((err) => {
        this.$emit('paid', this.selectedBank, 'FAIL')
        this.$error({
          title: '温馨提示',
          content: err.message,
          okText: '知道了'
        })
      })
    },
    fetchVRPay () {
      const params = {
        loginId: mainSettings.user?.get()?.loginName,
        airlineCode: mainSettings.airline
      }
      return virtualPayInfo(params)
    },
    vrPayInfoOkHandle () {
      this.vrPayModalVisible = false
      this.postPay()
    },
    checkVrPayBalance (vrPayBalance, order) {
      return !(vrPayBalance.surplusAmount < order.amount)
    },
    showWxQRCode (paymentNo, url) {
      const params = {
        paymentNo,
        url
      }
      showQRCode(params).then((res) => {
        if (res) {
          this.wxPayCodeVisible = true
          this.wxPayCode = 'data:image/jpg;base64,' + res

          this.pollPayStatus(paymentNo)
        }
      }).catch((err) => {
        this.wxPayCodeVisible = false
        this.$emit('paid', this.selectedBank, 'FAIL')

        this.$message.error(err.message || '微信二维码获取失败，请稍后再试')
      })
    },
    pollPayStatus (paymentNo) {
      let self = this
      this.pollPayInt = setInterval(() => {
        self.fetchPayStatus(paymentNo)
      }, 5000)
    },
    fetchPayStatus (paymentNo) {
      const params = {
        paymentNo
      }
      payState(params).then((res) => {
        if (res === 'PAY_SUCCESS') {
          this.$emit('paid', this.selectedBank, 'SUCCESS')

          window.clearTimeout(this.pollPayInt)
          if (this.wxPayReturnUrl && this.wxPayReturnUrl !== '') {
            this.$router.push({ path: this.wxPayReturnUrl })
          } else {
            // vue-router 会对参数进行 encodeURIComponent, 不需要重复 encodeURIComponent
            const returnUrl = this.returnUrl.replace('/micro/main', '')
            this.$router.push({ path: returnUrl, query: { extra_common_param: this.extraCommonParam } })
          }
        }
      }).catch(() => {
        // 默认查询次数结束如还未成功，默认按失败返回
        if (this.pollPayIntCount > 0) {
          this.pollPayIntCount--
          return
        }

        this.wxPayCodeVisible = false
        this.$emit('paid', this.selectedBank, 'FAIL')
        window.clearTimeout(this.pollPayInt)
      })
    },
    doHiddenPayMethod (payHidden = [], copyGroup) {
      payHidden.forEach(group => {
        const i = _.findIndex(copyGroup, { title: group.title })

        if (i > -1) {
          const _group = copyGroup[i]
          group.items.forEach(item => {
            const idx = _.findIndex(_group.items, { id: item.id })

            if (idx > -1) {
              _group.items.splice(idx, 1)
            }
          })

          if (!_group.items.length) {
            copyGroup.splice(i, 1)
          }
        }
      })
    },
    doFilterPayMethod (payFilter = [], copyGroup) {
      let payMethodGroupFilter = []

      copyGroup.forEach((group) => {
        let filtered = []
        _.each(payFilter, (fil) => {
          let temp = _.filter(group.items, (payMethod) => {
            return payMethod.id === fil.bankId
          })

          filtered = filtered.concat(temp)
        })

        if (filtered.length) {
          payMethodGroupFilter.push(Object.assign(group, {
            items: filtered
          }))
        }
      })

      return payMethodGroupFilter
    },
    // 扩展支付方式
    doExtendPayMethod (list = [], copyGroup) {
      list.forEach(group => {
        const i = _.findIndex(copyGroup, { title: group.title })

        if (i > -1) {
          const _group = copyGroup[i]
          group.items.forEach(item => {
            const idx = _.findIndex(_group.items, { id: item.id })

            if (idx > -1) {
              _group.items.splice(idx, 1, {
                ..._group.items[idx],
                ...item
              })
            }
          })
        }
      })
    },
    tabChangeHandler (activeKey) {
      let keyMap = _.map(this.payMethodGroup, (group) => (group.title))

      this.$emit('tabChange', {
        key: activeKey,
        label: keyMap[activeKey]
      })
    },
    onSelectPeriods (periods) {
      this.periods = periods
    }
  }
}
</script>

<style lang="less">
  /*支付标签页*/
  .pay-card-container {
    background: #f5f5f5;
    overflow: hidden;
  }
  .pay-card-container > .ant-tabs-card > .ant-tabs-content {
    min-height: 120px;
    max-height: 300px;
    margin-top: -16px;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
    background: #f5f5f5;
    padding: 20px 32px;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-bar {
    border-color: #f5f5f5;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
    border-color: #dddddd;
    background: #ffffff;
    border-radius: 0;
    margin-right: 0;
    padding: 0 40px;
    border-bottom: 1px solid #dddddd;
  }

  .pay-card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
    border-color: #dddddd;
    background: #f5f5f5;
    color: #808080;
    border-radius: 0;
    padding: 0 40px;
    border-bottom: 1px solid transparent;
  }

  .pay-type-item {
    display: inline-block;
    margin: 5px 13px;
    width: 170px;
    min-height: 44px;
    text-align: center;
    cursor: pointer;
    .pay-type-icon {
      display: inline-block;
      border: 1px solid #ccc;
      height: 44px;
      line-height: 44px;
    }

    &.active {
      .pay-type-icon {
        border: 1px solid #e94250;
      }
    }
  }

  .wx-pay-code {
    text-align: center;
  }

  .vr-info-item {
    margin: 10px 0;

   .vr-label {
     display: inline-block;
     box-sizing: border-box;
     padding: 0 20px;
     width: 40%;
     text-align: right;
   }

    .vr-context {
      display: inline-block;
    }
  }

  .vr-pay-note {
    color: @primary-color;
    text-align: center;
  }

  @media only screen  and (max-width: 768px) {
    .pay-type-item {
      margin: 5px 0;
      width: 100%;
    }
  }
</style>
